import React, { useState, useEffect } from 'react';
import axios from 'axios';
import styles from './MediaCard.module.css';
import {
  PLATFORM_STATIC_ICONS,
  VIDEO_PLACEHOLDER
} from '../../../../config/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faClapperboardPlay,
  faPlay,
  faFilePdf
} from '@fortawesome/pro-duotone-svg-icons';
import { faXmark } from '@fortawesome/pro-solid-svg-icons';
import ProgressBar from 'react-bootstrap/ProgressBar';
import toast from 'react-hot-toast';
import { RequestCouldntBeCompletedToasterMessage } from '../../../../utils/toasterMessage';
import { useTranslate } from '@tolgee/react';
import { useDispatch, useSelector } from 'react-redux';
import {
  addUnEditedMediaFiles,
  clearImageThumbnail,
  deleteAfile,
  fileUploadStatus,
  setMediaDataAttribute,
  setModalUiContent,
  updateCancelToken,
  updateMultiImageEditorCloseState
} from '../../../../redux/slices/lomavisCreator/lomavisCreator';
import { lomavisCreatorRootState } from '../../../../pages/lomavisCreator';
import axiosClient from '../../../../utils/axios';
import {
  EXTERNAL,
  IMAGE,
  MEDIA_TYPE_IMAGE,
  MEDIA_TYPE_VIDEO,
  VIDEO
} from '../../config/constants';
import ImageWithLoading from '../commonElements/imageWithLoading';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { ALL } from '../../../../config/constants';
import { POST_TYPE_TEMPLATE } from '../../config/platformFeatures';

interface Props {
  item: any;
  index: number;
  source: any;
  setUploadCount: React.Dispatch<React.SetStateAction<number>>;
  setTotalUploadCount: React.Dispatch<React.SetStateAction<number>>;
  platform: string;
  setAutoImageModToggle: Function;
  cropMode: boolean;
  disableAutomaticEditor?: boolean;
}
interface MediaObject {
  uploaded: boolean;
  id: string;
  newUpload: boolean;
  media_type: string;

  // Other properties...
}

const MediaCard: React.FC<Props> = ({
  item,
  index,
  source,
  setUploadCount,
  platform,
  setTotalUploadCount,
  setAutoImageModToggle,
  cropMode,
  disableAutomaticEditor = false
}) => {
  const [imageError, setImageError] = useState(false);
  const [progress, setProgress] = useState(0);
  const [uploading, setUploading] = useState(false);
  const [isThumbnailValid, setIsThumbnailValid] = useState(false);

  const { t } = useTranslate();
  const dispatch = useDispatch();
  const postData = useSelector(
    (state: lomavisCreatorRootState) => state.lomavisCreator.postData[platform]
  );
  const lomavisCreator = useSelector(
    (state: lomavisCreatorRootState) => state.lomavisCreator
  );

  const editedThumbnail = useSelector(
    (state: lomavisCreatorRootState) =>
      state.lomavisCreator.postData[platform]?.editedImageThumbnail
  );
  const brandMediaModal = useSelector(
    (state: lomavisCreatorRootState) =>
      state.lomavisCreator.modalStates.brandMediaEditor
  );

  const layeredThumbnail = useSelector(
    (state: lomavisCreatorRootState) =>
      state.lomavisCreator.postData[platform]?.layeredImageThumbnail
  );
  const postIsOverlay = useSelector(
    (state: lomavisCreatorRootState) => state.lomavisCreator.overlay_enabled
  );
  const overlay_enabled =
    lomavisCreator.general_post_type === POST_TYPE_TEMPLATE || postIsOverlay;

  const openBrandOverlayModal = () => {
    if (!brandMediaModal.toggle && cropMode) {
      dispatch(
        setModalUiContent({
          modal: 'brandMediaEditor',
          attribute: 'toggle',
          value: true
        })
      );
      dispatch(
        setModalUiContent({
          modal: 'brandMediaEditor',
          attribute: 'platform',
          value: ALL
        })
      );
      dispatch(
        setModalUiContent({
          modal: 'brandMediaEditor',
          attribute: 'currentIndex',
          value: index
        })
      );
      dispatch(
        setModalUiContent({
          modal: 'brandMediaEditor',
          attribute: 'cropMode',
          value: true
        })
      );
    }
  };

  useEffect(() => {
    if (postData?.media[0]?.media_type == VIDEO) {
      setIsThumbnailValid(true);
    } else {
      setIsThumbnailValid(false);
    }
  }, [postData?.media]);

  const putWithFile = async (url, file, headers, file_type) => {
    setUploading(true);
    const source = axios.CancelToken.source();

    await dispatch(
      updateCancelToken({
        token: source
      })
    );

    try {
      const config = {
        headers: headers ? { ...headers, 'Content-Type': file_type } : {} // Set headers property with provided headers
      };

      const response = await axios.put(url, file, {
        ...config,
        cancelToken: source?.token,
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          setProgress(percentCompleted);
        }
      });

      // Return the response data

      setUploadCount((prevCount) => prevCount + 1);

      console.log('return data', response);

      try {
        const res = await axiosClient.put(item.uploadPreset?.confirm_url, {
          success: true
        });

        await dispatch(
          setMediaDataAttribute({
            platform,
            uuid: item?.uuid,
            attribute: 'isUploading',
            value: false
          })
        );
        await dispatch(
          fileUploadStatus({
            platform,
            fileID: item.id
          })
        );
        setUploading(false);
        return res.data;
      } catch (err: any) {
        console.log(err);
        throw err;
      }
    } catch (error) {
      await dispatch(
        setMediaDataAttribute({
          platform,
          uuid: item?.uuid,
          attribute: 'isUploading',
          value: false
        })
      );
      if (axios.isCancel(error)) {
        console.log('Request canceled:', error.message);
      } else {
        toast.error(`${item.id}: ${t('errors.request_couldnt_be_completed')}`, {
          duration: 4000,
          position: 'top-right'
        });
        const res = error.response;

        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        console.error(`Looks like there was a problem. Status Code: ${error}`);

        console.error('Error:', error);
        throw error;
      }
      toast.error(`${item.id}: ${t('errors.request_couldnt_be_completed')}`, {
        duration: 4000,
        position: 'top-right'
      });

      // Dispatch deleteAfile action inside the catch block
      await deleteAsset(item?.id, item?.uuid);
      await dispatch(
        deleteAfile({
          platform,
          fileID: item.id,
          uuid: item.uuid
        })
      );

      setUploading(false);
    }
  };

  // Example usage
  const url = item.uploadPreset?.url;
  const file_type = item.file_type;
  const file = item.file;
  const headers = item.uploadPreset?.headers; // Example header

  useEffect(() => {
    // check if item is uploaded from source other from local upload i.e mediaLibrary to trigger multiImage Editor
    const externalUploadArray = (postData.media as MediaObject[]).filter(
      (obj) => obj?.newUpload === true
    );
    const lastItemInExternalArray = externalUploadArray.slice(-1)[0]?.id;

    if (
      externalUploadArray.length > 0 &&
      externalUploadArray.some(
        (obj) =>
          obj.media_type === MEDIA_TYPE_IMAGE ||
          obj.media_type === MEDIA_TYPE_VIDEO
      )
    ) {
      if (
        (item?.media_type === 'image' || 'video') &&
        item.editorUpdateState === true
      ) {
        !disableAutomaticEditor &&
          !overlay_enabled &&
          dispatch(
            addUnEditedMediaFiles({
              platform,
              files: [item]
            })
          );
      }

      if (lastItemInExternalArray === item?.id) {
        dispatch(
          updateMultiImageEditorCloseState({
            state: false
          })
        );

        if (!disableAutomaticEditor) {
          if (overlay_enabled) {
            openBrandOverlayModal();
          } else {
            setAutoImageModToggle();
          }
        }

        dispatch(
          setMediaDataAttribute({
            platform,
            uuid: item?.uuid,
            attribute: 'newUpload',
            value: false
          })
        );
      }

      return;
    }
    if (uploading) {
      return;
    }

    //if upload is from local continue upload process and PUT file to end point
    const newArray = (postData.media as MediaObject[]).filter(
      (obj) => obj.uploaded === false
    );
    const firstThree = newArray.slice(0, 1)?.map((obj) => obj.id);
    const lastItem = newArray.slice(-1)[0]?.id;

    if (firstThree.includes(item.id) && !uploading) {
      putWithFile(url, file, headers, file_type)
        .then((responseData) => {
          if (
            (item?.media_type === 'image' || 'video') &&
            item.editorUpdateState === true
          ) {
            !disableAutomaticEditor &&
              !overlay_enabled &&
              dispatch(
                addUnEditedMediaFiles({
                  platform,
                  files: [item]
                })
              );
          }

          if (lastItem === item.id) {
            setTotalUploadCount(0);
            setUploadCount(0);
            if (
              item.media_type === MEDIA_TYPE_IMAGE ||
              item.media_type === MEDIA_TYPE_VIDEO
            ) {
              if (!disableAutomaticEditor) {
                if (overlay_enabled) {
                  openBrandOverlayModal();
                } else {
                  setAutoImageModToggle();
                }
              }
            }
          }
          console.log('Upload successful:', responseData);
        })
        .catch((error) => {
          if (lastItem === item.id) {
            setTotalUploadCount(0);
            setUploadCount(0);
            if (
              (item.media_type === MEDIA_TYPE_IMAGE ||
                item.media_type === MEDIA_TYPE_VIDEO) &&
              postData.unEditedMedia?.length > 0
            ) {
              if (!disableAutomaticEditor) {
                if (overlay_enabled) {
                  openBrandOverlayModal();
                } else {
                  setAutoImageModToggle();
                }
              }
            }
          }
          console.error('Upload failed:', error);
        });
    }
  }, [postData.media]);
  const [deleting, setDeleting] = useState(false);

  const deleteThumbnail = async () => {
    const urlArray = [layeredThumbnail, editedThumbnail];

    // setDeleting(true);
    try {
      // Create an array of promises
      const deletePromises = urlArray.map((item) => {
        // const apiUrl = item?.uploadPresets?.uploaded_object_data?.api_url;
        const apiUrl = item?.media?.api_url;

        if (!apiUrl) {
          dispatch(
            clearImageThumbnail({
              platform
            })
          );
          setDeleting(false);
          return;
        }

        return axiosClient.delete(apiUrl);
      });

      // Await all promises
      const responses = await Promise.all(deletePromises);

      // Log responses
      responses.forEach((response) => {
        console.log('Response:', response.data);
      });
      setDeleting(false);
      // Dispatch the action current all deletes are done
      dispatch(
        clearImageThumbnail({
          platform
        })
      );
    } catch (error) {
      // Handle error
      dispatch(
        clearImageThumbnail({
          platform
        })
      );
      setDeleting(false);
      console.error('Error:', error);
    }
  };
  const deleteAsset = (id, uuid) => {
    const url = item?.api_url;
    setDeleting(true);
    dispatch(
      deleteAfile({
        platform,
        fileID: id,
        uuid: uuid
      })
    );

    setDeleting(false);

    // Make the POST request using Axios
    // setDeleting(true);
    if (!item?.saved_in_media_library) {
      axiosClient
        .delete(url)
        .then((response) => {
          setDeleting(false);
          // Handle successful response
          console.log('Response:', response.data);
        })
        .catch((error) => {
          // Handle error
          setDeleting(false);

          console.error('Error:', error);
        });
    }

    if (isThumbnailValid) {
      deleteThumbnail();
    }
  };

  return (
    <div
      style={{ position: 'relative', zIndex: 2 }}
      className={`${styles['image-container']} d-flex justify-content-center align-items-center`}
    >
      {/* {item.media_type === "video" && (
        <div
          style={{
            position: "absolute",
            borderRadius: "2px",
            top: "5px",
            left: "5px",
            zIndex: 10,
          }}
          className="w-20px badge bg-white d-flex justify-content-center align-items-center shadow"
        >
          <i className="fas fa-play" style={{ fontSize: "1.25em" }}></i>
        </div>
      )} */}

      <div
        style={{
          position: 'absolute',
          borderRadius: '2px',
          top: '5px',
          left: '5px',
          zIndex: 10
        }}
        className="w-20px badge bg-white d-flex justify-content-center align-items-center shadow"
      >
        {item.media_type === VIDEO ? (
          <i className="fa-regular fa-video" style={{ fontSize: '1.25em' }}></i>
        ) : item.media_type === IMAGE ? (
          <i className="fa-regular fa-image" style={{ fontSize: '1.25em' }}></i>
        ) : item.media_type === 'doc' ? (
          <i
            className="fa-regular fa-file-pdf text-danger"
            style={{ fontSize: '1.25em' }}
          ></i>
        ) : (
          <i style={{ fontSize: '1.25em' }}></i>
        )}
      </div>

      <div
        className="w-20px position-absolute bottom-0 end-0 d-flex justify-content-center align-item-center badge cursor-pointer"
        style={{
          backgroundColor: '#adb5bd',
          alignItems: 'center',
          zIndex: 10
        }}
        onClick={() => {
          deleteAsset(item?.id, item?.uuid);
        }}
      >
        <div
          style={{
            aspectRatio: 1,
            alignItems: 'center',
            zIndex: 10,
            cursor: 'pointer'
          }}
          className="d-flex justify-content-center align-item-center rounded"
        >
          {deleting ? (
            <span
              style={{
                aspectRatio: 1,
                alignItems: 'center'
              }}
              className="spinner-border spinner-border-sm text-white ratio ratio-1x1"
              role="status"
              aria-hidden="true"
            ></span>
          ) : (
            <span
              style={{
                aspectRatio: 1,
                alignItems: 'center'
              }}
              className="text-white fw-bolder fs-7"
            >
              X
            </span>
          )}
        </div>
      </div>
      {/* {item.media_type !== "doc" && (
        <div
          style={{
            width: item.orientation === "landscape" ? "25%" : "15%",
            height: item.orientation === "portrait" ? "25%" : "15%",
            position: "absolute",
            backgroundColor: "white",
            borderRadius: "2px",
            bottom: "10px",
            right: "13px",
          }}
        ></div>
      )} */}
      {uploading && (
        <div
          style={{
            width: '75%',
            position: 'absolute',
            borderRadius: '2px',
            bottom: '10px',
            margin: '0 auto 0 auto',
            zIndex: 9
          }}
        >
          <ProgressBar striped variant="primary" animated now={progress} />
        </div>
      )}

      {!imageError &&
      (item.preview_image || item.thumbnail_image) &&
      item.media_type !== 'doc' ? (
        <div
          className={`h-100 w-100 bg-white d-flex justify-content-center align-items-center m-1`}
        >
          <ImageWithLoading
            src={item.preview_image ? item.preview_image : item.thumbnail_image}
            alt="placeholder"
            className="img-thumbnail m-1 h-100px w-100px rounded-2 m-1"
            style={{ objectFit: 'cover' }}
            fallbackText=""
          />
        </div>
      ) : item.media_type === 'video' ? (
        <div
          className={`${styles['empty-state']} h-100px w-100px bg-dark bg-opacity-25 d-flex justify-content-center align-items-center border border-white border-3 rounded-2 m-1`}
        >
          <img
            className=""
            style={{ width: '50%', height: '50%' }}
            src={PLATFORM_STATIC_ICONS.video_placeholder}
            draggable={false}
          />
        </div>
      ) : item.media_type === 'doc' ? (
        <div
          className={
            'm-1 h-100px w-100px d-flex flex-column border justify-content-center align-items-center p-5 bg-white'
          }
        >
          <i
            style={{ fontSize: '70px', height: '70px' }}
            className="fa-duotone fa-file-pdf text-danger "
          ></i>
        </div>
      ) : (
        <div
          className={
            'm-1 h-100px w-100px d-flex flex-column border justify-content-center align-items-center p-5 bg-white'
          }
        >
          <i
            style={{ fontSize: '70px', height: '70px' }}
            className="fa-duotone fa-solid fa-file text-primary"
          ></i>
        </div>
      )}
    </div>
  );
};

export default MediaCard;
